import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as Styled from "./style";

const PageNotFound = () => {
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate(-1);
  };

  return (
    <Styled.NotFoundContainer>
      <Styled.MessageBox>
        <Styled.ErrorMessage variant="h5">
          404: Page Not Found
        </Styled.ErrorMessage>
        <Styled.Description variant="body1">
          The page you are looking for doesn’t exist or has been moved.
        </Styled.Description>
        <Button variant="contained" color="primary" onClick={goToDashboard}>
          Back to previous page
        </Button>
      </Styled.MessageBox>
    </Styled.NotFoundContainer>
  );
};

export default PageNotFound;
